import React from "react";
import '../assets/style/project.css';

function Project({ title, image, description, techstack, githubLink ,live_demo }) {
  return (
		<article className='rounded-xl  mt-10 overflow-hidden shadow-xl shadow-slate-300 dark:shadow-slate-900 text-white'>
			<img src={image} alt='' loading='lazy' className="w-full h-1/2 hover:scale-110 transition duration-500 " />
			<div className='dark:bg-dark-card p-2 card-content flex flex-col hover:translate-y-[-20px] transition duration-700'>
				<h1 className=' font-semibold text-lg pt-1'>
					{title}
				</h1>
				<p className='text-content pt-4 font-light'>{description}</p>
				<h3 className='text-dark-heading dark:text-light-heading font-medium pt-4'>
					Tech Stack : <span className='font-light'>{techstack}</span>
				</h3>
					<div className='flex self-start'>
					{live_demo && <a
							href={live_demo}
							target='_blank'
							rel='noreferrer noopener'
							className='pl-2  dark:text-blue-100 font-bold align-bottom hover:text-blue-500 transition duration-300 '>
							Live Demo
						</a>}
						{
							githubLink && 
								<a
									href={githubLink}
									target='_blank'
									rel='noreferrer noopener'
									className='pl-2  dark:text-blue-100 font-bold hover:text-blue-500 transition duration-300 '>
									View Code
								</a>
						}
					</div>
			</div>
		</article>
	);
}

export default Project;
